import { Link } from "react-router-dom";
import { ShieldCheck, Gem, Handshake, ArrowRight } from "lucide-react";

const VALUES = [
  { icon: ShieldCheck, title: "Gizlilik", desc: "Mülk sahiplerimizin ve müşterilerimizin bilgilerini en yüksek gizlilik standardıyla koruruz." },
  { icon: Gem, title: "Prestij", desc: "Yılların getirdiği tecrübeyle, bölgenin nitelikli ve değerli gayrimenkulleri portföyümüze dahil ederiz." },
  { icon: Handshake, title: "Güven", desc: "Her işlemde şeffaflık ve dürüstlükle, uzun soluklu ilişkiler inşa ederiz." },
];

const CorporateIntroSection = () => (
  <section className="py-16 md:py-20 border-t border-[color:var(--line)]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
      <div className="flex flex-col gap-4">
        <span className="text-sm font-medium text-[color:var(--brand-gold-2)] uppercase tracking-wide">Kurumsal</span>
        <h2 className="font-[var(--font-serif)] text-2xl md:text-3xl font-semibold tracking-[-0.01em] text-[color:var(--brand-charcoal)]">
          Gayrimenkul Danışmanlığında Anlayışımız
        </h2>
        <p className="text-sm md:text-base text-[color:hsl(var(--muted-foreground))] leading-relaxed">
          Abdullah Karslı Gayrimenkul Danışmanlığı; kaliteyi, gizliliği ve sağlam yatırım vizyonunu esas alan bir
          anlayışla hizmet verir. Her mülk kendine has bir hikaye taşır; biz bu hikayeyi doğru sahibiyle
          buluşturuyoruz.
        </p>
        <Link
          to="/hakkimizda"
          data-testid="home-about-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[color:var(--brand-charcoal)] gold-hairline w-fit"
        >
          Hakkımızda Daha Fazlası <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {VALUES.map((v) => {
          const Icon = v.icon;
          return (
            <div key={v.title} className="rounded-[14px] border border-[color:var(--line)] bg-[color:hsl(var(--card))] p-5 flex flex-col gap-3">
              <div className="h-10 w-10 rounded-[10px] gold-gradient-surface flex items-center justify-center">
                <Icon className="h-5 w-5 text-[color:var(--brand-charcoal)]" />
              </div>
              <h3 className="font-[var(--font-serif)] text-base text-[color:var(--brand-charcoal)]">{v.title}</h3>
              <p className="text-xs text-[color:hsl(var(--muted-foreground))] leading-relaxed">{v.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default CorporateIntroSection;
